// src/pages/Contacts.jsx (o src/components/Contacts.jsx se lo tieni lì)
import React from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import "../css/contatti.css";
import Strip from "../components/Strip";

export default function Contacts() {
  const social = [
    {
      label: "lylescoaching",
      aria: "Instagram",
      url: "https://www.instagram.com/lylescoaching?igsh=MWRhNHJubDJveG56Zw==",
    },
    { label: "Facebook", aria: "Facebook", url: null },
    { label: "TikTok", aria: "TikTok", url: null },
  ];

  return (
    <main className="contacts py-5">
      <Container fluid="xl">
        {/* HERO */}
        <header className="contacts-hero text-center">
          <h2 className="contacts-title text-light">CONTACT ME</h2>
          <p className="contacts-lead">
            Get in touch for personal training, small-group coaching, or
            tailored strength &amp; conditioning plans.
          </p>
        </header>

        {/* GRID */}
        <Row className="g-4">
          {/* Contact Details */}
          <Col xs={12} lg={4}>
            <Card className="contact-card shadow-sm accent-left">
              <Card.Body>
                <Card.Title as="h2" className="h5 mb-2">
                  Contact Details
                </Card.Title>
              </Card.Body>
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Email:</strong>{" "}
                  <a href="mailto:joubertlyle62@gmail.com">
                    joubertlyle62@gmail.com
                  </a>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Phone:</strong>{" "}
                  <a href="tel:+393466509237">+39 346 650 9237</a>
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Location:</strong> Pesaro, ITALY
                </ListGroup.Item>
              </ListGroup>
            </Card>
          </Col>

          {/* Social */}
          <Col xs={12} lg={4}>
            <Card className="contact-card shadow-sm">
              <Card.Body>
                <Card.Title as="h2" className="h5 mb-2">
                  Social
                </Card.Title>

                <ListGroup variant="flush">
                  {social.map((s) => (
                    <ListGroup.Item key={s.label}>
                      {s.url ? (
                        <a
                          className="social-link"
                          href={s.url}
                          aria-label={s.aria}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {s.label}
                        </a>
                      ) : (
                        <span
                          className="social-link text-muted"
                          aria-label={`${s.aria} (coming soon)`}
                          style={{ cursor: "not-allowed" }}
                        >
                          {s.label} (coming soon)
                        </span>
                      )}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>

          {/* Hours / Location */}
          <Col xs={12} lg={4}>
            <Card className="contact-card shadow-sm">
              <Card.Body>
                <Card.Title as="h2" className="h5 mb-2">
                  Availability
                </Card.Title>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong>Mon–Fri:</strong> 07:00–20:00
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Sat:</strong> 08:00–13:00
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>Sun:</strong> By appointment
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>

          {/* Venue */}
          <Col xs={12} lg={6}>
            <Card className="contact-card shadow-sm">
              <Card.Body>
                <Card.Title as="h2" className="h5 mb-2">
                  Training Venue
                </Card.Title>
                <p className="mb-2">
                  <strong>SMASH Sport Center</strong> — Via Toscana - PESARO -
                  ITALY
                </p>
                <p className="mb-0 text-muted">
                  Personal and private sessions available. Remote coaching on
                  request.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Strip />
    </main>
  );
}
